import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { RequestService } from '../../services/requests.services';

@Component({
  selector: 'app-related-requests',
  templateUrl: './related-requests.component.html',
  styleUrls: ['./related-requests.component.css']
})
export class RelatedRequestsComponent implements OnInit, OnDestroy {
  requests: any;
  @Input() requestId?: number;
  @Input() requirementId?: number;
  isrelatedRequestLoaded = false;
  requestSubscription?: Subscription;
  constructor(private readonly requestService: RequestService) {
  }
  ngOnInit(): void {
    this.getRelatedRequests();
  }

  getRelatedRequests() {
    this.requestSubscription =this.requestService.getLinkedRequestToRequirement(Number(this.requestId), Number(this.requirementId)).subscribe({
      next: (response) => { this.requests = response; this.isrelatedRequestLoaded = true; },
      error: (error) => console.log(error),
      complete: () => { }
    })
  }
 
  ngOnDestroy(): void {
    this.requestSubscription?.unsubscribe();
  }

}
